export const defaultBuildingsQuery = {
	_limit: 25,
	_sortColumn: 'address',
	_sortDirection: 'asc',
	mapAreaType: 'city',
};

export const buildingsInclude = 'clients';

export const perPageVals = [5, 15, 25, 30, 60, 100, 200];

export const sortOptions = [
	{value: 'address', title: 'Address'},
	{value: 'manufacturingYear', title: 'Manufacturing year'},
	{value: 'zip', title: 'ZIP code'},
	{value: 'city', title: 'Municipality'},
];

export const buildingsFiltersKeys = [
	'encounterState',
	'dateFrom',
	'dateTo',
	'manufacturingYearStart',
	'manufacturingYearEnd',
	'unknownManufacturingYear',
	'onlyWithClientWithPhone',
	'onlyUnknownBuildings',
	'zip',
	'city',
	'municipalName',
	'_q',
	'areas',
];

export const emptyBuildingsFilters = {
	encounterState: '',
	dateFrom: null,
	dateTo: null,
	manufacturingYearStart: null,
	manufacturingYearEnd: null,
	unknownManufacturingYear: false,
	onlyWithClientWithPhone: false,
	onlyUnknownBuildings: false,
	zip: null,
	city: '',
	municipalName: '',
	q: '',
	areas: [],
};

export const massSelectionLimit = 15000;
